import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { CommonDataService } from 'src/sb-tools/typescript/services/common-data.service';
import { environment } from '@environment';
import { CustomerReplyPortalReplyModel } from '../models/customer-reply-portal-reply-model.model';
import { HttpTransportType, HubConnection, HubConnectionBuilder, LogLevel } from '@microsoft/signalr';

@Injectable()
export class SignalRService {
    connection: HubConnection;

    private subjects = {
        onReplyAddedSubject: new Subject<CustomerReplyPortalReplyModel>(),
    };

    constructor(private commonDataService: CommonDataService) {}

    reconnect(): void {
        this.stopConnect();
        this.startConnect();
    }

    /// /////////////////// CLIENT METHODS ////////////////////
    onReplyAdded(): Observable<CustomerReplyPortalReplyModel> {
        return this.subjects.onReplyAddedSubject.asObservable();
    }

    /// /////////////////// PRIVATE METHODS ////////////////////
    private activateClientsListeners() {
        this.connection.on('replyAdded', (reply: CustomerReplyPortalReplyModel) => {
            this.subjects.onReplyAddedSubject.next(reply);
        });
    }

    private getAuthorizationParams(): string {
        return (
            '?community=' +
            this.commonDataService.community +
            '&X-Token=' +
            encodeURIComponent(this.commonDataService.xToken)
        );
    }

    private startConnect(): void {
        const params = this.getAuthorizationParams();
        console.log('SignalR connects');

        this.connection = new HubConnectionBuilder()
            .withUrl(environment.signalrServerUrl + '/customerReplyPortalHub' + params, HttpTransportType.WebSockets)
            .configureLogging(LogLevel.Information)
            .build();

        this.activateClientsListeners();

        this.connection
            .start()
            .then(() => {
                console.log('SignalR connected');
                console.log(this.connection);
            })
            .catch(() => {
                setTimeout(() => {
                    this.reconnect();
                }, 5000);
            });

        this.connection.onclose(() => {
            console.log('SignalR disconnected');
            setTimeout(() => {
                this.reconnect();
            }, 5000);
        });
    }

    private stopConnect(): void {
        if (this.connection) {
            this.connection.stop();
        }
        this.connection = null;
    }
}
